"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobManager = void 0;
var job_1 = require("./job/job");
var search_jobs_response_1 = require("./responses/search-jobs-response");
/**
 * @param {Configuration} configuration
 * @param {HTTPClient} httpClient
 * @doc JobManager
 */
var JobManager = /** @class */ (function () {
    function JobManager(configuration, httpClient) {
        this.configuration = configuration;
        this.httpClient = httpClient;
        /**
         * @type {string}
         */
        this.baseUrl = 'https://' + configuration.domain;
        /**
         * @type {string}
         */
        this.apiUrl = this.baseUrl + "/_api/jobs";
    }
    /**
     * @param {string} jobId
     * @returns {Promise<Job<T>>}
     */
    JobManager.prototype.getJob = function (jobId) {
        return this.httpClient
            .get(this.apiUrl + "/" + jobId)
            .then(function (response) {
            return new job_1.Job(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @param {string} groupId
     * @returns {Promise<Job<T>[]}
     */
    JobManager.prototype.getJobGroup = function (groupId) {
        // TODO: convert Job<any>[] to a more typed solution
        // For this will need to move specifications to discriminated unions
        return this.httpClient
            .get(this.apiUrl + "/groups/" + groupId, {})
            .then(function (response) {
            return response.payload.map(function (data) { return new job_1.Job(data); });
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @param {SearchJobsRequest} searchJobsRequest
     * @returns {Promise<SearchJobsResponse>}
     */
    JobManager.prototype.searchJobs = function (searchJobsRequest) {
        var params = __assign({}, searchJobsRequest);
        return this.httpClient
            .get(this.apiUrl, params)
            .then(function (response) {
            return new search_jobs_response_1.SearchJobsResponse(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    return JobManager;
}());
exports.JobManager = JobManager;
//# sourceMappingURL=job-manager.js.map